import useGetLatestExaminationResult, { QmsExamPaperStatus } from './useGetLatestExaminationResult';

export { QmsExamPaperStatus };
export default useGetLatestExaminationResult;
